import React from 'react';
import Link from 'next/link';
import { LinkData } from '../../helpers/common';

interface BreadcrumbsProps {
  breadcrumbs: LinkData[];
}
export default function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps): JSX.Element {
  return (
    <h3>
      {breadcrumbs &&
        breadcrumbs.map((link, index) => {
          return (
            <span key={link.name}>
              {link.link ? (
                <Link href={link.link} legacyBehavior>
                  {link.name}
                </Link>
              ) : (
                <span>{link.name}</span>
              )}
              {/* eslint-disable-next-line @typescript-eslint/no-magic-numbers */}
              {index === breadcrumbs.length - 1 ? '' : '/'}
            </span>
          );
        })}
    </h3>
  );
}
